export const CURR_MOVIE="CURR_MOV"
export const SIMILAR_MOVIES="SIMILAR_MOVIES"
export const ALLOW_SINGLE_MOVIE="ALLOW_SINGLE_MOVIE"